import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/new/components/shadcn/dialog';

interface Props {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  itemNoun: 'fact' | 'document';
  currentSelectionCount: number;
  newItemCount: number;
  onConfirm: (mode: 'add' | 'replace') => void;
}

export function ApplyToPageSelectionDialog({
  isOpen,
  onOpenChange,
  itemNoun,
  currentSelectionCount,
  newItemCount,
  onConfirm,
}: Props) {
  const pluralNoun = `${itemNoun}s`;
  const pageNoun = itemNoun === 'fact' ? 'facts page' : 'docs page';
  const hasExisting = currentSelectionCount > 0;

  const handleSelect = (mode: 'add' | 'replace') => {
    onConfirm(mode);
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <Icon className={itemNoun === 'fact' ? 'lucide--list-checks' : 'lucide--file-check'} />
            Select on {pageNoun}
          </DialogTitle>
        </DialogHeader>

        <p>
          {hasExisting ? (
            <>
              You currently have <strong>{currentSelectionCount}</strong>{' '}
              {currentSelectionCount === 1 ? itemNoun : pluralNoun} selected on the {pageNoun}. How should we apply the{' '}
              <strong>{newItemCount}</strong> {newItemCount === 1 ? itemNoun : pluralNoun} from this answer?
            </>
          ) : (
            <>
              Apply the <strong>{newItemCount}</strong> {newItemCount === 1 ? itemNoun : pluralNoun} from this answer to
              the {pageNoun} selection.
            </>
          )}
        </p>

        <DialogFooter>
          {hasExisting && (
            <Button onClick={() => handleSelect('replace')}>
              <Icon className="lucide--refresh-cw" />
              Replace selection
            </Button>
          )}
          <Button variant="primary" onClick={() => handleSelect('add')}>
            <Icon className="lucide--plus" />
            {hasExisting ? 'Add to existing selection' : 'Apply selection'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
